// extracted by mini-css-extract-plugin
export var banner = "_s9-0";
export var settingRow = "_s9-2";
export var titleIcon = "_s9-1";